import { Check, ArrowRight, ChevronRight, CreditCard, Shield, X, Sparkles, CalendarDays, Info  } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { SITE_CONFIG, PRICING_CONFIG } from "@/config/site";
import { Link } from "react-router-dom";

import tryqvpnImg from "../assets/icon-tryqvpn.svg";
import secPayImg from "../assets/icon-secpay.svg";

export const PricingPage = () => {
  const plans = PRICING_CONFIG.quantumPlans;
  const { freeTier } = PRICING_CONFIG;

  return (
    <div className="pt-24 pb-20 inner-contact-page1 bg-black-v2">
      {/* Hero */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-20 mb-16">
        {/* <Badge className="section-badge mb-6">
          <CreditCard className="w-3 h-3 text-violet-400" />
          <span>Pricing</span>
        </Badge> */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          A Plan for Everyone
        </h1>
        <p className="text-lg text-gray-400 max-w-2xl mx-auto">
          Get quantum safe protection with a plan that fits your needs. Start free or save up to 70% with longer terms.
        </p>
      </section>

      {/* Pricing Cards */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-12 md:gap-6 lg:gap-8">
          
            <div className="group relative overflow-visible p-8 rounded-3xl flex flex-col mob-bottoms h-full transition-all duration-500
                ease-out hover:-translate-y-2 hover:scale-[1.01] hover:shadow-[0_0_35px_rgba(16,185,129,0.12)] mb-10- bg-white/[0.03] border border-white/10 cardbg1">
                {/* <div className="absolute -top-3 left-6 w-max z-10">
                  <span className="px-4 py-1 rounded-full tag">
                    BADGE
                  </span>
                </div> */}

              <div className="mb-6">
                <h2 className="text-2xl font-bold text-white mb-1">STANDARD</h2>
                <p className="white-text-400 text-sm"></p>
              </div>

              <div className="mb-6">
                <div className="flex items-baseline">
                  <span className="text-3xl md:text-5xl font-bold text-white">
                    $0
                  </span>
                </div>
                <div className="text-sm white-text-4001 text-gray-300 mt-2">Essential VPN protection</div>
                <div className="text-xs white-text-500 mt-1"></div>
                {/* <div className="inline-block mt-3 px-2 py-0.5 text-xl font-medium text-emerald-400 bg-emerald-500/10 rounded-full">
                  Save 50%
                </div> */}
              </div>

              <div className="border-t border-white/10 pt-3 mb-8 space-y-4">

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Daily</span>
                </div>

                <span className="font-semibold text-emerald-400">
                  FREE
                </span>

              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Weekly</span>
                </div>

                <span className="font-semibold text-emerald-400">
                  FREE
                </span>

              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Monthly</span>
                </div>

                <span className="font-semibold text-emerald-400">
                  FREE
                </span>

              </div>

              <div className="flex items-center justify-between">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Yearly</span>
                </div>

                <span className="font-semibold text-emerald-400">
                  FREE
                </span>

              </div>

              <div className="flex items-center justify-between h-3"></div>
              <div className="flex items-center justify-between h-3"></div>

            </div>

              <ul className="space-y-3 bullet-blk flex-grow min-h-[140px]--">
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Quantum safe encryption</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Limited server access with ads</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Supports 1 device</span>
                  </li>
              </ul>
              
              <Link to="/#download">
              <Button
                className="w-full btn-gradient1 btn-gradient-new">
                Get Started <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
              </Link>
            </div> {/* Plan 1 */}

            <div className="group relative overflow-visible p-8 rounded-3xl flex flex-col mob-bottoms h-full transition-all duration-500
                ease-out hover:-translate-y-2 hover:scale-[1.01] hover:shadow-[0_0_35px_rgba(16,185,129,0.12)] mb-10- cardbg">
                <div className="absolute -top-3 left-6 w-max z-10">
                  <span className="px-4 py-1 rounded-full tag">
                    Popular
                  </span>
                </div>

              <div className="mb-6">
                <h2 className="text-2xl font-bold text-white mb-1">PREMIUM</h2>
                {/* <p className="white-text-400 text-sm">DURATION</p> */}
              </div>

              <div className="mb-6">
                <div className="flex items-baseline">
                  <span className="text-3xl md:text-5xl font-bold text-white">
                    $2 <span className="text-xl font-light text-white">/Daily</span>
                  </span>
                </div>
                <div className="text-sm white-text-4001 text-gray-300 mt-2">Flexible premium plans</div>
                {/* <div className="text-sm white-text-400 mt-2">PER</div>
                <div className="text-xs white-text-500 mt-1">BILLING</div> */}
                  {/* <div className="inline-block mt-3 px-2 py-0.5 text-xl font-medium text-emerald-400 bg-emerald-500/10 rounded-full">
                    Save 50%
                  </div> */}
              </div>

              <div className="border-t border-white/10 pt-3 mb-8 space-y-4">

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Daily</span>
                </div>

                <span className="font-semibold text-white-400">
                  $2.00
                </span>

              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Weekly</span>
                </div>

                <span className="font-semibold text-white-400">
                  $8.00
                </span>

              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Monthly</span>
                </div>

                <span className="font-semibold text-white-400">
                  $20.00
                </span>

              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Yearly</span>
                </div>

                <span className="font-semibold text-white-400">
                  $100.00
                </span>

              </div>

              <div className="flex items-center justify-between">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />

                  <span className="text-gray-200">
                    Yearly (Pay Monthly)
                  </span>

                  {/* Tooltip */}
                  <div className="relative">

                    <Info className="peer w-4 h-4 text-emerald-400/80 cursor-pointer" />

                    <div className="absolute bottom-full left-1/2 mb-3 w-72 -translate-x-1/2 rounded-xl border border-emerald-500/20 bg-[#08120f] p-4 text-sm leading-6 text-gray-300 opacity-0 invisible transition-all duration-300 peer-hover:opacity-100 peer-hover:visible z-20 shadow-[0_10px_30px_rgba(0,0,0,0.45)]">

                      $12.50/mo Commit to 1 year. Pay monthly. Cancel anytime after 12 months.

                    </div>

                  </div>

                </div>

                <span className="font-semibold text-white-400">
                  $150.00
                </span>

              </div>{/**/}

            </div>

              <ul className="space-y-3 bullet-blk flex-grow min-h-[140px]--">
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Everything in Standard</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Access to premium servers</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Priority support</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Early access to new features</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Faster speeds</span>
                  </li>                  
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Supports up to 3 devices</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Ad-free experience</span>
                  </li>
              </ul>
              
              <Link to="/#download">
              <Button
                className="w-full btn-gradient1 btn-gradient-new">
                Get Started <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
              </Link>
            </div> {/* Plan 2 */}

            <div className="group relative overflow-visible p-8 rounded-3xl flex flex-col mob-bottoms h-full transition-all duration-500
                ease-out hover:-translate-y-2 hover:scale-[1.01] hover:shadow-[0_0_35px_rgba(16,185,129,0.12)] mb-10- bg-white/[0.03] border border-white/10 cardbg1">
                <div className="absolute -top-3 left-6 w-max z-10">
                  <span className="px-4 py-1 rounded-full tag">
                    Best Value
                  </span>
                </div>

              <div className="mb-6">
                <h2 className="text-2xl font-bold text-white mb-1">PRO</h2>
                {/* <p className="white-text-400 text-sm">DURATION</p> */}
              </div>

              <div className="mb-6">
                <div className="flex items-baseline">
                  <span className="text-3xl md:text-5xl font-bold text-white">
                    $3 <span className="text-xl font-light text-white">/Daily</span>
                  </span>
                </div>
                <div className="text-sm white-text-4001 text-gray-300 mt-2">Maximum performance & security</div>
                {/* <div className="text-sm white-text-400 mt-2">PER</div>
                <div className="text-xs white-text-500 mt-1">BILLING</div> */}
                  {/* <div className="inline-block mt-3 px-2 py-0.5 text-xl font-medium text-emerald-400 bg-emerald-500/10 rounded-full">
                    Save 50%
                  </div> */}
              </div>

              <div className="border-t border-white/10 pt-3 mb-8 space-y-4">

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Daily</span>
                </div>

                <span className="font-semibold text-white-400">
                  $3.00
                </span>

              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Weekly</span>
                </div>

                <span className="font-semibold text-white-400">
                  $10.00
                </span>

              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Monthly</span>
                </div>

                <span className="font-semibold text-white-400">
                  $25.00
                </span>

              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Yearly</span>
                </div>

                <span className="font-semibold text-white-400">
                  $150.00
                </span>

              </div>

              <div className="flex items-center justify-between">

                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />

                  <span className="text-gray-200">
                    Yearly (Pay Monthly)
                  </span>

                  {/* Tooltip */}
                  <div className="relative">

                    <Info className="peer w-4 h-4 text-emerald-400/80 cursor-pointer" />

                    <div className="absolute bottom-full left-1/2 mb-3 w-72 -translate-x-1/2 rounded-xl border border-emerald-500/20 bg-[#08120f] p-4 text-sm leading-6 text-gray-300 opacity-0 invisible transition-all duration-300 peer-hover:opacity-100 peer-hover:visible z-20 shadow-[0_10px_30px_rgba(0,0,0,0.45)]">

                      $16.66/mo Commit to 1 year. Pay monthly. Cancel anytime after 12 months.

                    </div>

                  </div>

                </div>

                <span className="font-semibold text-white-400">
                  $200.00
                </span>

              </div>{/**/}

            </div>

              <ul className="space-y-3 bullet-blk flex-grow min-h-[140px]--">
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Everything in Premium</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Maximum speeds (zero throttling)</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Lowest price guaranteed</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">All server locations</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">Supports up to 5 devices</span>
                  </li>
              </ul>
              
              <Link to="/#download">
              <Button
                className="w-full btn-gradient1 btn-gradient-new">
                Get Started <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
              </Link>
            </div> {/* Plan 3 */}

        </div>
      </section>

      {/* Free Tier Callout */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
        <div className="rounded-3xl bg-white/[0.03] border border-white/10 p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            <div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center tryimg">
                  {/* <Sparkles className="w-5 h-5 text-violet-300" /> */}
                  <img src={tryqvpnImg} alt={freeTier.name} />
                </div>
                <h3 className="text-2xl font-bold text-white">{freeTier.name}</h3>
              </div>
              <p className="text-gray-400 text-sm">{freeTier.body}</p>
            </div>

            <ul className="space-y-3">
              {freeTier.features.map((feature, i) => (
                <li key={i} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-violet-600/201 tick-cl flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 white-text-400" />
                  </div>
                  <span className="text-gray-300 text-sm">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="flex md:justify-end">
              <Link to="/#download">
              <Button className="btn-primary1 btn-gradient-new  inline-flex items-center gap-2" data-testid="pricing-free-tier-cta">
                {freeTier.cta}
                <ChevronRight className="w-4 h-4" />
              </Button>
              </Link>
            </div>
          </div>
        </div>
        <p className="text-center text-gray-500 text-sm mt-6">{freeTier.subtext}</p>
      </section>

      {/* Feature Comparison */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 animate-fade-in-up text-center">QVPN vs Traditional VPNs</h2>
        <div className="rounded-3xl bg-white/[0.03] border border-white/10 overflow-hidden">
          <div className="grid grid-cols-3 border-b border-white/10">
            <div className="p-4 md:p-6 text-sm font-medium text-gray-300">Feature</div>
            <div className="p-4 md:p-6 text-sm font-medium text-gray-300 text-center">Traditional VPNs</div>
            <div className="p-4 md:p-6 text-sm font-semibold text-violet-300 text-center qvpn-ft">QVPN</div>
          </div>
          {[
            { feature: "Current threat protection", traditional: true, qvpn: true },
            { feature: "Quantum attack protection", traditional: false, qvpn: true },
            { feature: "Future proof encryption", traditional: false, qvpn: true },
            { feature: "Zero logs policy", traditional: "Varies", qvpn: true },
            { feature: "Post quantum cryptography", traditional: false, qvpn: true }
          ].map((row, i, arr) => (
            <div
              key={i}
              className={`grid grid-cols-3 ${i !== arr.length - 1 ? "border-b border-white/5" : ""}`}
            >
              <div className="p-4 md:p-6 text-sm text-gray-300">{row.feature}</div>
              <div className="p-4 md:p-6 text-center">
                {typeof row.traditional === "boolean" ? (
                  row.traditional ? <Check className="w-5 h-5 text-emerald-400 mx-auto" /> : <X className="w-5 h-5 text-gray-600 mx-auto" />
                ) : (
                  <span className="text-gray-400 text-sm">{row.traditional}</span>
                )}
              </div>
              <div className="p-4 md:p-6 text-center">
                {typeof row.qvpn === "boolean" ? (
                  row.qvpn ? <Check className="w-5 h-5 text-emerald-400 mx-auto" /> : <X className="w-5 h-5 text-gray-600 mx-auto" />
                ) : (
                  <span className="text-white text-sm">{row.qvpn}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Billing FAQ */}
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 animate-fade-in-up text-center">Billing Questions</h2>
        <div className="space-y-4">
          <div className="p-6 rounded-2xl bg-white/[0.03] border border-white/10">
            <h3 className="text-white font-semibold mb-2">How does billing work?</h3>
            <p className="text-gray-400 text-sm">
              Subscriptions are billed based on the plan you choose (monthly, annually, or every 2 years). {PRICING_CONFIG.billing.renewalNote}
            </p>
          </div>
          <div className="p-6 rounded-2xl bg-white/[0.03] border border-white/10">
            <h3 className="text-white font-semibold mb-2">Can I cancel anytime?</h3>
            <p className="text-gray-400 text-sm">{PRICING_CONFIG.billing.cancellationNote}</p>
          </div>
          <div className="p-6 rounded-2xl bg-white/[0.03] border border-white/10">
            <h3 className="text-white font-semibold mb-2">What if my payment fails?</h3>
            <p className="text-gray-400 text-sm">{PRICING_CONFIG.billing.gracePeriodNote}</p>
          </div>
          <div className="p-6 rounded-2xl bg-white/[0.03] border border-white/10">
            <h3 className="text-white font-semibold mb-2">What happens when my subscription expires?</h3>
            <p className="text-gray-400 text-sm">
              When your subscription ends, your account automatically reverts to the Free plan with limited daily usage. You can continue using {SITE_CONFIG.brand.name} on the Free plan or resubscribe to a paid plan at any time.
            </p>
          </div>
          <div className="p-6 rounded-2xl bg-white/[0.03] border border-white/10">
            <h3 className="text-white font-semibold mb-2">Can I get a refund?</h3>
            <p className="text-gray-400 text-sm">{PRICING_CONFIG.refund.note}</p>
          </div>
        </div>
      </section>

      {/* Payment Security */}
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="p-8 rounded-3xl bg-white/[0.03] border border-white/10 text-center">
          <img src={secPayImg} className="w-12 h-12 text-violet-400 mx-auto mb-4" />
          <h3 className="text-2xl font-bold text-white mb-6">Secure Payments</h3>
          <p className="text-gray-400 text-sm mb-4">{PRICING_CONFIG.billing.securityNote}</p>
          <p className="text-gray-500 text-sm">
            Your payment appears as "{PRICING_CONFIG.billing.statementDescriptor}" on your statement.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PricingPage;
